import React, { useEffect, useMemo, useState } from "react";
import { CircularProgress, DialogTitle, Box, Typography, Dialog, Button, Divider } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { saveAs } from 'file-saver';
import Cookies from "universal-cookie";
import JSZip from "jszip";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";

import Etiqueta_controller from '../../../../../../../../../../../../controllers/etiqueta';
import { useModal } from "../../../../../../../../../../hooks/useModal";

import CardPedido from "../../../../../../../../../../../util/cardPedido/.mixins/index";
import CloseButton from "../../../../../../../../../../../util/buttonClose/.mixins/buttonClose";
import ModalManualEtiqueta from '../../../../../../../../../../../util/manualEtiquetas/.mixins';
import CardNotaFiscal from "../../cardNotaFiscal/index";
import { DownloadConcluido } from "../../../../todosPedidos/childrens/downloadEtiquetas/downloadConcluido";
import { DownloadOpcoes } from "../../downloadOpcoes";

export default function DetalheOpcaoRecebimento({
  ChangeModalDetailState,
  isOpenModalDetail,
  props,
}) {
  const columns = [
    {
      name: "NR_PC",
      label: "Número pedido",
    },
    {
      name: "CD_NUM",
      label: "Cód Numérico",
    },
    {
      name: "CD_ALFA",
      label: "Alfa",
    },
    {
      name: "NM_PROD",
      label: "Nome produto",
    },
    {
      name: "AB_COR1",
      label: "Cor",
    },
    {
      name: "QTD",
      label: "Quantidade",
    },
    {
      name: "ds_opcao_pag",
      label: "Opção de pagamento",
    },
  ];

  const [infoPedidoProtocolo, setInfoPedidoProtocolo] = useState([]);
  const [modalManual, setModalManual] = useState(false);

  useEffect(() => {
    let pinfo = props.state.infoPedidoProtocolo;
    pinfo.bt_component = [
      // {
      //     label: "DOWNLOAD DETALHES",
      //     variant:"text",
      //     startIcon: faFileDownload,
      //     handler: () => {
      //         console.log("Click agendamento!");
      //     }
      // },
      {
        label: "DOWNLOAD MANUAL DE ETIQUETAS",
        variant: "text",
        startIcon: faFileDownload,
        handler: () => {
          setModalManual(true);
        }
      }
    ];
    setInfoPedidoProtocolo(pinfo);
  }, [props.state.detalhePedidoProtocolo]);

  function HeaderModal() {
    return (
      <div>
        <CloseButton closeMethod={ChangeModalDetailState} />
        <Typography style={{ marginLeft: "20px" }} variant="h6" align="center">
          {"Detalhes do Pedido"}
        </Typography>
      </div>
    );
  }

  function TableModal() {
    return (
      <div>
        <MUIDataTable
          maxWidth={"md"}
          data={props.state.detalhePedidoProtocolo}
          columns={columns}
          options={{
            title: false,
            print: false,
            filter: false,
            download: false,
            search: false,
            viewColumns: false,
            size: "small",
            selectableRows: "none",
            responsive: "scrollFullHeight",
            rowsPerPage: 4,
            rowsPerPageOptions: false,
          }}
        />
      </div>
    );
  }

  const { Modal: ModalEtiquetaOpcoes, toggleModal: toggleModalEtiquetaOpcoes } = useModal();
  const { Modal: ModalEtiquetaConcluido, toggleModal: toggleModalEtiquetaConcluido } = useModal();

  const handleClickModalDownloadEtiquetas = (tipo) => {
    toggleModalEtiquetaOpcoes();
    handleClickDownloadEtiquetas(tipo).catch(error => console.error(error));
  };

  const getProdutos = () => {
    const produtos = props.state.detalhePedidoProtocoloNF
      .map((item) => parseInt(item.ID_PROD));

    const unique_id_prods = [...new Set(produtos)];
    return unique_id_prods;
  };

  const handleClickDownloadEtiquetas = async (tipo) => {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    const numero_maximo_de_etiquetas_por_requisicao = 50;

    const produtos = getProdutos();
  
    let p=0;
    for (let p = 0; p < produtos.length; p = p + numero_maximo_de_etiquetas_por_requisicao) {
      const zip = new JSZip();
      const idProdutos = produtos.slice(p,numero_maximo_de_etiquetas_por_requisicao);
      ChangeModalDetailState();
      props.setState({
        progressPercentZipBoolean: true,
      });

      let j_o_postUrls = [];
      // chunk parametro de quantidade de requisicoes /urls

      let i, j, temporary, chunk = 1;
      for (i = 0, j = idProdutos.length; i < j; i += chunk) {
        temporary = idProdutos.slice(i, i + chunk);
        const o_postUrls = await Etiqueta_controller.postUrls(tipo, temporary, token);
        const jr = await o_postUrls.json();
        j_o_postUrls = j_o_postUrls.concat(jr);
      }

      if (j_o_postUrls == null) {
        return;
      }

      const bar = new Promise((resolve, reject) => {
        j_o_postUrls.forEach(async (keyname, i, array) => {
          const query = { key: keyname, UserToken: token };
          const o_qualidade = await Etiqueta_controller.getDownload(query);
          const o_qualidade_blob = await o_qualidade.blob();
          const name = keyname.split("/")[3];
          zip.file(name, o_qualidade_blob);
          if (i === array.length - 1) resolve();
        });
      });

      bar.then(() => {
        // timeout necessário para esperar a escrita do arquivo pra dentro do zip
        setTimeout(() => {
          zip.generateAsync({
            type: "blob",
            compression: "DEFLATE",
            streamFiles: true,
            compressionOptions: { level: 6 }
          },
            updateCallback
          ).then((content) => {
            saveAs(content, `Etiquetas expedição T&S_${new Date().getTime()}.zip`);
          });
        }, 1000);
      });
    }
  };

  const updateCallback = (metaData) => {
    const percent = metaData.percent;
    // timeout necessário para atualização do metadata
    setTimeout(() => {
      props.setState({
        progressPercentZip: percent.toFixed(2),
        progressPercentZipBoolean: true
      });

      if (percent === 100) {
        setTimeout(() => {
          props.setState({
            progressPercentZip: 0,
            progressPercentZipBoolean: false,
          });
          toggleModalEtiquetaConcluido();
        }, 1000);
      }
    }, 10);
  };

  const ModalDetail = useMemo(() => {
    return ({ children }) =>
      isOpenModalDetail && (
        <Dialog open={isOpenModalDetail} fullWidth maxHeight={"md"} maxWidth={"md"}>
          {children}
        </Dialog>
      );
  }, [isOpenModalDetail]);

  return (
    <>
      <ModalDetail>
        <Box p={2}>
          <DialogTitle>
            <HeaderModal />
          </DialogTitle>
          {props.state.isLoading && (
            <div align="center">
              <CircularProgress />
            </div>
          )}
          {!props.state.isLoading && (
            <>
              <CardPedido {...infoPedidoProtocolo} />
              <TableModal />
              <Typography style={{ margin: "6px" }} variant="h6">
                Notas fiscais desta entrega
              </Typography>
              <CardNotaFiscal
                dataNotaFiscal={props.state.detalhePedidoProtocoloNF}
                title={`OPÇÕES DE PAGAMENTO: ${infoPedidoProtocolo.ds_opcao_pag}`}
              />
            </>
          )}
        </Box>

        <Divider style={{ marginTop: "10px" }} />

        <Box width="250px" margin="20px auto">
          <Button
            variant="contained"
            color="primary"
            startIcon={
              <i className="material-icons">
                file_download
              </i>
            }
            onClick={toggleModalEtiquetaOpcoes}
          >
            DOWNLOAD ETIQUETA
          </Button>
        </Box>
      </ModalDetail>

      <ModalEtiquetaOpcoes>
        <DownloadOpcoes
          handleClick={handleClickModalDownloadEtiquetas}
          toggleModal={toggleModalEtiquetaOpcoes}
        />
      </ModalEtiquetaOpcoes>

      <ModalEtiquetaConcluido>
        <DownloadConcluido toggleModal={toggleModalEtiquetaConcluido} />
      </ModalEtiquetaConcluido>

      <ModalManualEtiqueta
        setModalManual={setModalManual}
        modalManual={modalManual}
      />
    </>
  );
}